export default __webpack_public_path__ + "static/media/via_btc.70d12119.png";